module.exports = __webpack_public_path__ + "static/media/9.8b5741aa.jpg";